export const ProfileIcon = ({ color = "#DBBE78", size = 19, ...props }) => (
    <svg
        width={size}
        height={size * (18 / 19)}
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9.5 2.51875C10.805 2.51875 11.8625 3.5175 11.8625 4.75C11.8625 5.9825 10.805 6.98125 9.5 6.98125C8.195 6.98125 7.1375 5.9825 7.1375 4.75C7.1375 3.5175 8.195 2.51875 9.5 2.51875ZM9.5 12.0812C12.8413 12.0812 16.3625 13.6325 16.3625 14.3125V15.4813H2.6375V14.3125C2.6375 13.6325 6.15875 12.0812 9.5 12.0812ZM9.5 0.5C7.01375 0.5 5 2.40188 5 4.75C5 7.09812 7.01375 9 9.5 9C11.9862 9 14 7.09812 14 4.75C14 2.40188 11.9862 0.5 9.5 0.5ZM9.5 10.0625C6.49625 10.0625 0.5 11.4862 0.5 14.3125V17.5H18.5V14.3125C18.5 11.4862 12.5037 10.0625 9.5 10.0625Z"
            fill={color}
        />
    </svg>
);
